<script setup>
import { computed } from 'vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  bannerMessage: { type: String, default: '' },
  hrefLink: { type: String, default: '' },
  hrefLinkText: { type: String, default: '' },
  hasActionButton: { type: Boolean, default: false },
  actionButtonVariant: { type: String, default: 'faded' },
  actionButtonLabel: { type: String, default: '' },
  actionButtonIcon: { type: String, default: 'i-lucide-arrow-right' },
  colorScheme: { type: String, default: '' },
  hasCloseButton: { type: Boolean, default: false },
});
const emit = defineEmits(['primaryAction', 'close']);
const color = computed(
  () =>
    ({
      primary: 'blue',
      secondary: 'slate',
      alert: 'ruby',
      warning: 'amber',
      success: 'teal',
      gray: 'slate',
    })[props.colorScheme] || 'slate'
);
</script>

<template>
  <Banner :color="color" class="woot-banner w-full">
    {{ bannerMessage }}
    <a
      v-if="hrefLink"
      :href="hrefLink"
      class="ms-1 text-inherit underline underline-offset-2"
      rel="noopener noreferrer nofollow"
      target="_blank"
      >{{ hrefLinkText }}</a
    >
    <template v-if="hasActionButton || hasCloseButton" #actions>
      <Button
        v-if="hasActionButton"
        type="button"
        size="sm"
        :icon="actionButtonIcon"
        :variant="actionButtonVariant"
        :color="color"
        :label="actionButtonLabel"
        @click="emit('primaryAction', $event)"
      />
      <Button
        v-if="hasCloseButton"
        type="button"
        size="sm"
        icon="i-lucide-x"
        variant="ghost"
        :color="color"
        :aria-label="$t('GENERAL_SETTINGS.DISMISS')"
        :title="$t('GENERAL_SETTINGS.DISMISS')"
        @click="emit('close', $event)"
      />
    </template>
  </Banner>
</template>
